import { Injectable } from "@angular/core";
import {
  AlertController,
  ModalController,
  Platform,
  ToastController,
} from "@ionic/angular";
import { Store } from "@ngrx/store";
import { TranslateService } from "@ngx-translate/core";
import { FirebaseRecaptchaLoginComponent } from "src/app/popups/firebase-recaptcha-login/firebase-recaptcha-login.component";
import { MagicLoginConfirmationComponent } from "src/app/popups/magic-login-confirmation/magic-login-confirmation.component";
import * as AuthActions from "../../auth/store/auth.actions";
import * as fromApp from "../../store/app.reducer";
import * as _ from "lodash";
import { AnalyticsServiceService } from "../analitycsService/analytics-service.service";
import { first } from "rxjs";
import { FirebaseRecaptchaLoginReservationActiveComponent } from "src/app/popups/firebase-recaptcha-login-reservation-active/firebase-recaptcha-login-reservation-active.component";
import { MagicLoginConfirmationReservationActiveComponent } from "src/app/popups/magic-login-confirmation-reservation-active/magic-login-confirmation-reservation-active.component";
import { OnlyDineInLoginAssistService } from "../only-dinein-login-assist/only-dinein-login-assist.service";
@Injectable({
  providedIn: "root",
})
export class LoginPopupsServiceService {
  private FirebaseRecaptchaModal: any;
  private modalMagicLoginConfirmation: any;
  private magicLoginAlertMobile: any;
  private errorToast: any;

  constructor(
    private modalCtrl: ModalController,
    private alertController: AlertController,
    private translateService: TranslateService,
    private toastController: ToastController,
    private store: Store<fromApp.AppState>,
    private platform: Platform,
    private analyticsService: AnalyticsServiceService,
    private onlyDineInLoginAssistService: OnlyDineInLoginAssistService
  ) {}

  presentFirebaseModalLogin(resend, mobile, auto_fill_mobile) {
    // Only prefetch the "Only Dine-In capability" (tables signal) during login boot.
    // GPS should be requested only when the user explicitly taps "Resend SMS"
    // (guest-offer eligibility check), not when opening the login UI.
    this.onlyDineInLoginAssistService.prefetchOnlyDineInCapabilityForCurrentStore();
    if (!this.FirebaseRecaptchaModal) {
      this.FirebaseRecaptchaModal = true;
      this.showFirebaseModalLogin(resend, mobile, auto_fill_mobile);
    }
  }

  public async showFirebaseModalLogin(resend, mobile, auto_fill_mobile) {
    this.store
      .select("groupApp")
      .pipe(first())
      .subscribe(async (state) => {
        const FirebaseRecaptchaModalSettings = {
          component: FirebaseRecaptchaLoginComponent,
          backdropDismiss: false,
          cssClass: "fireBaseRecaptchaModal",
          componentProps: {
            resend: resend,
            customerMobile: mobile,
            auto_fill_mobile: auto_fill_mobile,
          },
        };

        const fireBaseRecaptchaLoginReservationActiveModalSettings = {
          component: FirebaseRecaptchaLoginReservationActiveComponent,
          backdropDismiss: true,
          breakpoints: [0, 0.5, 0.8, 1],
          initialBreakpoint: 0.8,
          cssClass: "fireBaseRecaptchaLoginReservationActiveModal",
          componentProps: {
            resend: resend,
            customerMobile: mobile,
          },
        };

        try {
          this.FirebaseRecaptchaModal = await this.modalCtrl.create(
            state && state.groupApp && state.groupApp.active_reservation_app
              ? fireBaseRecaptchaLoginReservationActiveModalSettings
              : FirebaseRecaptchaModalSettings
          );
          await this.FirebaseRecaptchaModal.present();
          this.FirebaseRecaptchaModal.onDidDismiss().then(() => {
            this.FirebaseRecaptchaModal = null;
          });
        } catch (e) {
          // presentFirebaseModalLogin sets FirebaseRecaptchaModal to the literal
          // `true` sentinel BEFORE this runs, and that one field gates the whole
          // LOGIN button. If creating or presenting the modal ever fails, leaving
          // the sentinel behind disables login for the rest of the session with
          // no visible error - the button simply stops responding. Release it.
          console.log("showFirebaseModalLogin failed", e);
          this.FirebaseRecaptchaModal = null;
        }
      })
      .unsubscribe();
  }

  public closeFirebaseModalLogin() {
    if (this.FirebaseRecaptchaModal) {
      // The field holds the literal `true` sentinel between the open request and
      // the overlay actually existing, and true.dismiss() is a TypeError that
      // would escape to the caller. Clearing it is the right outcome either way.
      if (typeof this.FirebaseRecaptchaModal.dismiss === "function") {
        this.FirebaseRecaptchaModal.dismiss();
      }
      this.FirebaseRecaptchaModal = null;
    }
  }

  public closeConfirmationLoginModal() {
    if (this.modalMagicLoginConfirmation) {
      this.modalMagicLoginConfirmation.dismiss();
      this.modalMagicLoginConfirmation = null;
    }
  }

  public async presentConfiramtionLoginModal(newCustomer) {
    this.store
      .select("groupApp")
      .pipe(first())
      .subscribe(async (state) => {
        const MagicLoginConfirmationSettings = {
          component: MagicLoginConfirmationComponent,
          componentProps: { newCustomer: newCustomer },
          backdropDismiss: false,
          cssClass: "magicLoginConfirmation",
        };

        const MagicLoginConfirmationReservationActiveSettings = {
          component: MagicLoginConfirmationReservationActiveComponent,
          componentProps: { newCustomer: newCustomer },
          backdropDismiss: true,
          breakpoints: [0, 0.5, 0.8, 1],
          initialBreakpoint: 0.8,
          cssClass: "magicLoginConfirmationReservationActive",
        };

        this.modalMagicLoginConfirmation = await this.modalCtrl.create(
          state && state.groupApp && state.groupApp.active_reservation_app
            ? MagicLoginConfirmationReservationActiveSettings
            : MagicLoginConfirmationSettings
        );

        await this.modalMagicLoginConfirmation.present();
        this.modalMagicLoginConfirmation.onDidDismiss().then((data) => {
          this.modalMagicLoginConfirmation = null;
          if (data) {
          }
        });
      })
      .unsubscribe();
    console.log("new customer inside magicloginModal", newCustomer);
  }

  public closeMobileMagicLoginAlert() {
    if (this.magicLoginAlertMobile) {
      // Same sentinel hazard as closeFirebaseModalLogin: between the open
      // request and the overlay existing this holds `true`, and true.dismiss()
      // throws.
      if (typeof this.magicLoginAlertMobile.dismiss === "function") {
        this.magicLoginAlertMobile.dismiss();
      }
      this.magicLoginAlertMobile = null;
    }
  }

  checkMobileMagicLoginIsOpen() {
    if (this.magicLoginAlertMobile) {
      return true;
    } else {
      return false;
    }
  }

  presentMobileMagicLoginAlert(newCustomer, groupApp, auto_fill_mobile) {
    console.log("magic login alert", this.magicLoginAlertMobile);
    if (!this.magicLoginAlertMobile) {
      this.magicLoginAlertMobile = true;
      this.showMobileMagicLoginAlert(newCustomer, groupApp, auto_fill_mobile);
    }
  }

  public async showMobileMagicLoginAlert(
    newCustomer,
    callerGroupApp,
    auto_fill_mobile
  ) {
    // Only prefetch the "Only Dine-In capability" (tables signal) during login boot.
    // GPS should be requested only when the user explicitly taps "Resend SMS"
    // (guest-offer eligibility check), not when opening the login UI.
    this.onlyDineInLoginAssistService.prefetchOnlyDineInCapabilityForCurrentStore();

    // Read groupApp from the store, the way the browser twin
    // (showFirebaseModalLogin) already does. Callers pass their own cached copy,
    // and a component that has not received the slice yet — or is mid-swap while
    // the dine-in guest strip is applied or restored — hands over undefined. That
    // used to fall through every branch below, opening nothing while leaving the
    // magicLoginAlertMobile sentinel set, which silently kills the LOGIN button.
    // The caller's copy is kept only as a fallback so no caller loses behaviour.
    const storeGroupApp = await new Promise<any>((resolve) => {
      this.store
        .select("groupApp")
        .pipe(first())
        .subscribe((state: any) => resolve(state ? state.groupApp : null))
        .unsubscribe();
    });
    const groupApp = storeGroupApp || callerGroupApp;

    if (groupApp && groupApp.active_reservation_app) {
      this.magicLoginAlertMobile = null;
      if (groupApp && groupApp.firebaseVerificationEnabled) {
        this.showFirebaseModalLogin(
          false,
          newCustomer && newCustomer.mobile ? newCustomer.mobile : null,
          null
        );
      } else {
        this.presentErrorToast(
          this.translateService.instant(
            "popups.magic-login-popup.you-are-in-a-test-version-of-the-app-you-cant-login"
          ),
          "danger"
        );
      }
    } else {
      if (groupApp && groupApp.firebaseVerificationEnabled) {
        this.magicLoginAlertMobile = await this.alertController.create({
          header: this.translateService.instant("homepage.magic-login"),
          cssClass: "maginLoginPopup",
          backdropDismiss: false,
          message: this.translateService.instant(
            "popups.magic-login-popup.please-enter-your-mobile"
          ),
          inputs: [
            {
              name: "mobile",
              type: "tel",
              value:
                newCustomer && newCustomer.mobile
                  ? newCustomer.mobile
                  : auto_fill_mobile
                  ? auto_fill_mobile
                  : "",
              id: "inputMobile",
              placeholder: this.translateService.instant(
                "popups.magic-login-confirmation.write-here"
              ),
            },
          ],
          buttons: [
            {
              text: this.translateService.instant(
                "popups.magic-login-confirmation.cancel"
              ),
              role: "cancel",

              cssClass: "secondary",
              handler: () => {
                console.log("Confirm Cancel");
              },
            },
            {
              text: "OK",
              role: "OK",

              handler: (data) => {
                if (data && data.mobile) {
                  this.analyticsService.dmAnalyticsMessage(
                    "submit_mobile_button",
                    null,
                    null,
                    null,
                    null,
                    null,
                    data.mobile,
                    null,
                    null,
                    null,
                    null
                  );
                  let mobile = _.cloneDeep(
                    data.mobile.toString().replace(/\s/g, "")
                  );
                  let newCustomer = {
                    gateway: "sms",
                    mobile: mobile,
                    createOneTimePass: true,
                  };
                  console.log(
                    "new customer before present magicloginModal",
                    newCustomer
                  );
                  this.store.dispatch(
                    new AuthActions.SetNewCustomer(newCustomer)
                  );
                  //this.presentMagicLoginConfirmationModal(newCustomer);
                } else {
                  if (this.errorToast) {
                    this.errorToast.dismiss();
                    this.errorToast = null;
                  }
                  this.presentErrorToast(
                    this.translateService.instant(
                      "popups.magic-login-popup.please-enter-your-mobile"
                    ),
                    "danger"
                  );
                  return false;
                }
              },
            },
          ],
        });

        const inputMobile: any = document.getElementById("inputMobile");
        if (inputMobile) {
          inputMobile.onkeyup = (ev) => {
            if (ev.key === "enter" || ev.keyCode === 13) {
              ev.preventDefault();
              if (inputMobile && inputMobile.value) {
                if (this.magicLoginAlertMobile) {
                  this.magicLoginAlertMobile.dismiss();
                  this.magicLoginAlertMobile = null;
                }
                this.analyticsService.dmAnalyticsMessage(
                  "submit_mobile_button",
                  null,
                  null,
                  null,
                  null,
                  null,
                  inputMobile.value,
                  null,
                  null,
                  null,
                  null
                );
                let mobile = _.cloneDeep(
                  inputMobile.value.toString().replace(/\s/g, "")
                );
                let newCustomer = {
                  gateway: "sms",
                  mobile: inputMobile.value,
                  createOneTimePass: true,
                };
                console.log(
                  "new customer before present magicloginModal",
                  newCustomer
                );
                this.store.dispatch(
                  new AuthActions.SetNewCustomer(newCustomer)
                );
                //this.presentMagicLoginConfirmationModal(newCustomer);
              } else {
                if (this.errorToast) {
                  this.errorToast.dismiss();
                  this.errorToast = null;
                }
                this.presentErrorToast(
                  this.translateService.instant(
                    "popups.magic-login-popup.please-enter-your-mobile"
                  ),
                  "danger"
                );
                return false;
              }
            }
          };
        }

        if (
          auto_fill_mobile &&
          this.magicLoginAlertMobile &&
          this.magicLoginAlertMobile.buttons
        ) {
          // Auto-submit path: the alert is built only to borrow its OK handler
          // and is deliberately NEVER presented. That is why the sentinel has to
          // be released by hand here — the onDidDismiss below can only fire for
          // an overlay that was actually shown, so on this path it never fires
          // and magicLoginAlertMobile would stay set for the rest of the session,
          // leaving the LOGIN button inert. The browser twin has no equivalent
          // hazard: it passes auto_fill_mobile into the modal as a prop and still
          // presents it, so its onDidDismiss always runs. This asymmetry is why
          // the dead button reproduced on native and not in the browser.
          const alertForAutoSubmit = this.magicLoginAlertMobile;
          setTimeout(async () => {
            try {
              const data = { mobile: auto_fill_mobile || "" };
              const okButton = alertForAutoSubmit.buttons[1];

              if (okButton && okButton.handler) {
                okButton.handler(data);
              }
            } finally {
              // Released only after the handler has run, so the field still acts
              // as the re-entrancy guard for this one-second window rather than
              // letting a second press start a parallel submit.
              this.magicLoginAlertMobile = null;
            }
          }, 1000);
          return;
        } else {
          try {
            await this.magicLoginAlertMobile.present();
          } catch (e) {
            // presentMobileMagicLoginAlert sets magicLoginAlertMobile to the
            // literal `true` sentinel before this runs, and that one field gates
            // the whole LOGIN button on native. Leaving it behind disables login
            // for the rest of the session with no visible error - the button
            // simply stops responding.
            console.log("showMobileMagicLoginAlert present failed", e);
            this.magicLoginAlertMobile = null;
            return;
          }
        }

        this.magicLoginAlertMobile
          .onDidDismiss()
          .then(() => {
            this.magicLoginAlertMobile = null;
          })
          .finally(() => {});
      } else {
        // Nothing was opened, so the sentinel must not survive here either:
        // presentMobileMagicLoginAlert gates the whole LOGIN button on this field
        // and otherwise clears it only from an overlay's onDidDismiss. The toast
        // told the customer something was wrong while the button stayed dead.
        this.magicLoginAlertMobile = null;
        this.presentErrorToast(
          this.translateService.instant(
            "popups.magic-login-popup.you-are-in-a-test-version-of-the-app-you-cant-login"
          ),
          "danger"
        );
      }
    }
  }

  async presentErrorToast(message, color) {
    this.errorToast = await this.toastController.create({
      message: message,
      duration: 3000,
      position: "middle",

      color: color,
      buttons: [
        {
          side: "end",
          icon: "assets/ionicons/close.svg",

          handler: () => {
            console.log("Toast Closed");
          },
        },
      ],
    });
    this.errorToast.present();
  }
}
